import React, { Fragment } from 'react'
import './index.scss'
const AnswersPart = (porps) => {
    const answerArr = porps.answers;
    return (
        <Fragment>
            {
                answerArr.map((item, index) => (<p key={index}>{item}</p>))
            }
        </Fragment>
    )
}

const DocPart = (props) => {
    const infoArr = props.infos;
    return (
        <div className="DocPart">
            {
                infoArr.map((item, index) => {
                    return (
                        <Fragment key={index}>
                            <h2 className="question">{item.question}</h2>
                            <div className="answers">
                                <AnswersPart answers={item.answers} />
                            </div>
                        </Fragment>
                    )
                })
            }
        </div>
    )
}

export default DocPart;


// WEBPACK FOOTER //
// ./src/containers/Edu/DocPart/index.js